import { Heart, Award, Stethoscope } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

const renderWithBold = (text) =>
  String(text)
    .split(/<strong>|<\/strong>/)
    .map((part, index) =>
      index % 2 === 1 ? (
        <strong key={`${part.slice(0, 12)}-${index}`} className="text-stone-800">
          {part}
        </strong>
      ) : (
        part
      )
    );

export const BiographySection = () => {
  const { t } = useLanguage();

  return (
    <section
      id="storia"
      className="py-24 md:py-32 bg-stone-50"
      data-testid="biography-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Image */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-[0_20px_60px_rgba(0,0,0,0.08)] max-w-sm mx-auto lg:mx-0">
              <img
                src="https://customer-assets.emergentagent.com/job_physio-letters/artifacts/trxo3ugd_20231121_095931.jpg"
                alt="Marlene Brochero - Fisioterapista"
                className="w-full h-[400px] object-cover object-top"
                data-testid="biography-image"
              />
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-4 -right-4 w-24 h-24 rounded-2xl bg-[#2c4c3b]/10 -z-10" />
            <div className="absolute -top-4 -left-4 w-16 h-16 rounded-full bg-[#d4c4a8]/30 -z-10" />
          </div>

          {/* Content */}
          <div>
            <span className="text-xs tracking-[0.2em] uppercase text-[#8a9a86] font-medium">
              {t('bio.label')}
            </span>
            <h2
              className="font-serif text-3xl sm:text-4xl lg:text-5xl text-stone-900 tracking-tight leading-tight mt-4 mb-6"
              data-testid="biography-title"
            >
              {t('bio.name')}
            </h2>
            <p className="text-stone-600 leading-relaxed mb-6">
              {renderWithBold(t('bio.p1'))}
            </p>
            <p className="text-stone-600 leading-relaxed mb-8">
              {renderWithBold(t('bio.p2'))}
            </p>

            {/* Credentials */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-2xl bg-[#e8ece6] flex items-center justify-center flex-shrink-0">
                  <Stethoscope className="w-5 h-5 text-[#2c4c3b]" strokeWidth={1.5} />
                </div>
                <div>
                  <p className="font-medium text-stone-900 text-sm">{t('bio.cred1')}</p>
                  <p className="text-xs text-stone-500">{t('bio.cred1sub')}</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-2xl bg-[#e8ece6] flex items-center justify-center flex-shrink-0">
                  <Heart className="w-5 h-5 text-[#2c4c3b]" strokeWidth={1.5} />
                </div>
                <div>
                  <p className="font-medium text-stone-900 text-sm">{t('bio.cred2')}</p>
                  <p className="text-xs text-stone-500">{t('bio.cred2sub')}</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-2xl bg-[#e8ece6] flex items-center justify-center flex-shrink-0">
                  <Award className="w-5 h-5 text-[#2c4c3b]" strokeWidth={1.5} />
                </div>
                <div>
                  <p className="font-medium text-stone-900 text-sm">{t('bio.cred3')}</p>
                  <p className="text-xs text-stone-500">{t('bio.cred3sub')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BiographySection;
